<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputNumber" });
import Input from "../input/Input.svelte";
export let value;
export let name;
export let mode = "integer";
export let type = "number";
export let label = void 0;
export let hint = void 0;
export let placeholder = void 0;
export let isDisabled = false;
export let isReadonly = false;
export let isRequired = true;
export let minimum = void 0;
export let maximum = void 0;
export let step = 1;
export let dimension = void 0;
const getHint = (hint2, minimum2, maximum2) => {
    if (hint2 !== void 0) {
        return hint2;
    }
    if (minimum2 !== void 0 && maximum2 !== void 0) {
        return `between ${minimum2} and ${maximum2}`;
    }
    if (minimum2 !== void 0) {
        return `Minimum: ${minimum2}`;
    }
    if (maximum2 !== void 0) {
        return `Maximum: ${maximum2}`;
    }
    return void 0;
};
const getKeyboard = (mode2, minimum2) => {
    if (minimum2 === void 0 || minimum2 < 0 || typeof maximum === "number" && maximum < 0) {
        return "text";
    }
    if (mode2 === "decimal") {
        return "decimal";
    }
    return "numeric";
};
const onBlur = () => {
    value = value === void 0 ? void 0 : Number(value);
};
$: defaultHint = getHint(hint, minimum, maximum);
$: keyboard = getKeyboard(mode, minimum);
</script>


<div class = 's8-input-number' class:s8-hide-spinner = { dimension !== undefined }>

    <Input
        bind:value
        hint = { defaultHint }
        { type }
        { keyboard }
        { minimum }
        { maximum }
        { label }
        { name }
        { isDisabled }
        { isReadonly }
        { isRequired }
        { placeholder }
        { step }
        on:blur = { onBlur }
    >
        <span slot = 'afterInput' class = 's8-dimension' class:s8-disabled = { isDisabled }>
            {#if dimension !== undefined}
                { dimension }
            {/if}
        </span>
    </Input>

</div>


<style>

    div.s8-input-number.s8-hide-spinner :global(input[type="number"]) {
                -webkit-appearance: textfield;
                -moz-appearance: textfield;
                appearance: textfield;
            }

                div.s8-input-number.s8-hide-spinner :global(input[type="number"])::-webkit-inner-spin-button,
                div.s8-input-number.s8-hide-spinner :global(input[type="number"])::-webkit-outer-spin-button {
                    -webkit-appearance: none;
                }

        div.s8-input-number span.s8-dimension  {
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
            color: rgba(39,39,17,0.36);
        }

        div.s8-input-number span.s8-dimension.s8-disabled {
                color: rgba(39,39,17,0.24);
            }</style>